import React from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { InsuranceDTO } from '../../../api/useInsuranceQuery';
import { selectCurrentClient } from '../../../../../CommonSelectors/CommonAreaSelector';

interface Props {
  data: InsuranceDTO;
}

export const PremiumEndYear = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  const owner = formBag.watch('AccountOwner');

  const { Dob: primaryDob, PartnerDob: spouseDob } = useSelector(selectCurrentClient);

  const primaryYob = primaryDob ? new Date(primaryDob).getFullYear() : null;
  const spouseYob = spouseDob ? new Date(spouseDob).getFullYear() : null;

  const isPrimary = owner === data.Options.InsuranceOwnerOptions.People[0].Name;
  const isSpouse = owner === data.Options.InsuranceOwnerOptions.People[1]?.Name;

  const options = data.Options.InsurancePremiumEndYearOptions.map((year, index) => {
    const yearNumber = Number(year);

    let rightLabel: string | undefined;

    if (Number.isInteger(yearNumber)) {
      if (isPrimary && primaryYob) {
        rightLabel = `Age ${yearNumber - primaryYob}`;
      } else if (isSpouse && spouseYob) {
        rightLabel = `Age ${yearNumber - spouseYob}`;
      }
    }

    return {
      label: year,
      value: index === 0 ? null : year,
      rightLabel,
    };
  });

  return (
    <Controller
      control={formBag.control}
      name="InsurancePremiumEndYear"
      render={({ field: { value, onChange } }) => {
        // We still want to show previously selected years
        // even if they are no longer part of the options
        const selectedValue =
          value === null
            ? { value, label: data.Options.InsurancePremiumEndYearOptions[0] }
            : { value, label: value };

        return (
          <Select
            label="Premium End Year"
            value={selectedValue}
            options={options}
            onChange={opt => onChange(opt?.value)}
            isPortal
          />
        );
      }}
    />
  );
};
